import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss')

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Dinners at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>May Wine Dinner</h1>
                <h2 className={classes.bold}>
                  May 7th <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;&middot;&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;&middot;&nbsp;</span> $55 Per Guest
                </h2>
                <h3>Hosted by Alabama Crown</h3>
                <h4>For Reservations: <br className={classes.br400} /> <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>


          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>                
                <h5>First Course</h5>
                <h4>Salmon Fritters</h4>
                <p>Salmon, Roasted Corn, Bell Peppers, Onions, Sweet and Spicy Mango Aioli</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Bodegas Ethereo · Rias Baixas · Albariño 2022</h4>
              </div>
 
              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>Pan Seared Scallops &amp; Fruit Salad</h4>
                <p>Arugula, Pickled Red Onion, Toasted Almonds, Watermelon, Grapefruit, Watermelon Vinaigrette</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Les Glories · Sauvignon Blanc · 2023</h4>
              </div>
              
              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>Smoked Duck with Truffle Ravioli</h4>
                <p>Port Wine and Mushroom Reduction</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Pertinace Langhe Nebbiolo · Red</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>Flourless Dark Chocolate Cherry Cake</h4>
                <p className={classes.pair}>Paired With</p>
                <h4>San Antonio Winery Port · California</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default wineDinner